import { render } from "./AdminCareSeekers.vue?vue&type=template&id=6dedd00a&scoped=true"
import script from "./AdminCareSeekers.vue?vue&type=script&lang=js"
export * from "./AdminCareSeekers.vue?vue&type=script&lang=js"

import "./AdminCareSeekers.vue?vue&type=style&index=0&id=6dedd00a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dedd00a"]])

export default __exports__